import { AppDispatch } from '@src/reducers';
import { initializeAmplify } from '@src/aws/amplify';
import { signInIfSessionActive } from '@src/actions/auth/actions';

export const initializeApp = (dispatch: AppDispatch) => {
  initializeAmplify();
  dispatch(signInIfSessionActive());
};
